import Promise from 'bluebird';
import _ from 'lodash';
import config from 'sharedConfig';
import crypto from 'crypto';

export function pluralize(singular, count = 0, plural) {
  if (!singular) return '';
  if (!plural) plural = singular + 's';
  return count === 1 ? singular : plural;
}

export function capitalize(phrase = '') {
  return phrase
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function localizeNumber(n) {
  return typeof n === 'number' ? n.toLocaleString() : n;
}

export function withConjunction(list = [], conjunction = 'and') {
  if (list.length === 0) return '';
  if (list.length === 1) return `${list[0]}`;
  if (list.length === 2) return `${list[0]} ${conjunction} ${list[1]}`;
  return `${list.slice(0, list.length - 1).join(', ')}, ${conjunction} ${
    list[list.length - 1]
  }`;
}

// https://stackoverflow.com/questions/35228052/debounce-function-implemented-with-promises
export function debounce(inner, ms = 0) {
  let timer = null;
  let resolves = [];

  return function(...args) {
    // Run the function after a certain amount of time
    clearTimeout(timer);
    timer = setTimeout(() => {
      // Get the result of the inner function, then apply it to the resolve function of
      // each promise that has been created since the last time the inner function was run
      let result = inner(...args);
      resolves.forEach(r => r(result));
      resolves = [];
    }, ms);

    return new Promise(r => resolves.push(r));
  };
}

export function isSmallScreen() {
  return typeof window !== 'undefined' && window.innerWidth < 768;
}

export function isMobileDevice() {
  if (typeof window === 'undefined') return;
  return /iPhone|iPod|iPad|Android/i.test(window.navigator.userAgent);
}

export function isIos() {
  if (typeof window === 'undefined') return;
  return /iphone|iPod|iPad/.test(window.navigator.appVersion.toLowerCase());
}

export function sanitizeHtml(string) {
  return string
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

export function sanitizeObject(obj, mapKeys = false) {
  if (mapKeys) obj = sanitizeKeys(obj);
  return _.mapValues(obj, val =>
    typeof val === 'string' ? sanitizeHtml(val) : val
  );
}

function sanitizeKeys(obj) {
  return _.mapKeys(obj, (val, key) =>
    typeof key === 'string' ? sanitizeHtml(key) : key
  );
}

export function formatContactNumber(str) {
  if (!str) return '';
  return str.slice(0, 3) + '-' + str.slice(3, 6) + '-' + str.slice(6);
}

export function generateRandomString(count) {
  let length = count || 25
  var crypto = require("crypto");
  var id = crypto.randomBytes(length).toString('hex');
  return id;
}
